export default __webpack_public_path__ + "static/media/hover-illustration.c40617ae.png";